<template>
  <!-- 公用面包屑 -->
  <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
    <el-breadcrumb-item v-if="(menuObject.menuList !== undefined && menuObject.menuList !== null) && (menuObject.secondItem === undefined || menuObject.secondItem === null)">
      {{menuObject.menuList[0].name}}
    </el-breadcrumb-item>
    <el-breadcrumb-item v-if="(menuObject.menuList !== undefined && menuObject.menuList !== null) && (menuObject.secondItem !== undefined && menuObject.secondItem !== null)" >
      <a @click="queryData(1,menuObject.menuList[0])" href="javascript:void(0)">{{menuObject.menuList[0].name}}</a>
    </el-breadcrumb-item>
    <el-breadcrumb-item v-if="(menuObject.secondItem !== undefined && menuObject.secondItem !== null) && (menuObject.thirdItem === undefined || menuObject.thirdItem === null)" >
      {{menuObject.secondItem.cateName?menuObject.secondItem.cateName:menuObject.secondItem.collectionName}}
    </el-breadcrumb-item>
    <el-breadcrumb-item v-if="(menuObject.secondItem !== undefined && menuObject.secondItem !== null) && (menuObject.thirdItem !== undefined && menuObject.thirdItem !== null)"  >
      <a @click="queryData(2,menuObject.secondItem)" href="javascript:void(0)">
        {{menuObject.secondItem.cateName?menuObject.secondItem.cateName:menuObject.secondItem.collectionName}}
      </a>
    </el-breadcrumb-item>
    <el-breadcrumb-item v-if="menuObject.thirdItem !== undefined && menuObject.thirdItem !== null">
      {{menuObject.thirdItem.cateName?menuObject.thirdItem.cateName:menuObject.thirdItem.collectionName}}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    menuObject: {
      type: Object

    },
    middleWare: {
      type: Function
    }
  },

  created() {
  },
  methods: {
    queryData(level, item) {
      localStorage.setItem('page_form', 'nav')
      // 如果点击级菜单，那么就将2级 3级的设置为undefined
      // let queryParams = {}
      // if (level === 1) {
      //   this.menuObject.secondItem = undefined
      //   this.menuObject.thirdItem = undefined
      //   // 一级菜单是一定存在的，不需要判断非空
      //   queryParams.firstId = this.menuObject.menuList[0].id
      // } else if (level === 2) {
      //   queryParams.firstId = this.menuObject.menuList[0].id
      //   queryParams.secondId = this.menuObject.secondItem.id
      //   this.menuObject.thirdItem = undefined
      // }
      localStorage.setItem('from', 'nav')
      localStorage.setItem('isNewProduct', '')
      localStorage.setItem('isNewProductId', '')
      // notes  haoyuanw  add  需要判断是不是newproduct 如果是则赋值
      if (item.seoUrl) {
        if (item.seoUrl.indexOf('new-product') > -1) {
          localStorage.setItem('isNewProduct', item.name)
          localStorage.setItem('isNewProductId', item.id)
        }
      }
      if (!item.cateName || (item['barType'] && item['barType']=='collection' )) {
        this.$router.push({path: '/collection' + item.seoUrl})
      } else {
        this.$router.push({path: '/category' + item.seoUrl})
      }
      // 此时需要调用product来更新 链接地址栏，保持最新的选中状态，所以不能调用父组件的方法了

      // this.$emit('middleWare', this.menuObject)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/components/breadcrumb.vue